import React from "react"
import { Button, ForwardIcon, Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import { InsuranceRecoveryFooter } from "./InsuranceRecoveryFooter"

type InsuranceUnavailableProps = { reason: "notCovered" | "noProviders"; onBack: () => void; onContinue: () => void }

export function InsuranceUnavailableStep({ reason, onBack, onContinue }: InsuranceUnavailableProps): JSX.Element {
  return (
    <>
      <Typography variant="h3" component="h1">
        {reason === "noProviders" ? (
          <FormattedMessage defaultMessage="No eligible providers are available" />
        ) : (
          <FormattedMessage defaultMessage="This visit isn't covered by your plan." />
        )}
      </Typography>
      <Typography>
        <FormattedMessage defaultMessage="You can still choose a time and pay out of pocket." />
      </Typography>
      <InsuranceRecoveryFooter onBack={onBack}>
        {/* Testing: keep self-pay available here; handle unavailable self-pay in a follow-up. */}
        <Button
          variant="outlined"
          color="secondary"
          size="small"
          onClick={onContinue}
          endIcon={<ForwardIcon />}
          fullWidth={false}
        >
          <FormattedMessage defaultMessage="Choose a time" />
        </Button>
      </InsuranceRecoveryFooter>
    </>
  )
}
